import React, {Component} from "react";
import ReactDOM from "react-dom";
import {StickyContext} from "./StickyContainer";

export default class Sticky extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isSticky: false,
            wasSticky: false,
            style: {}
        };
        this.handleContainerEvent = this.handleContainerEvent.bind(this);
        if (!props.render || (typeof props.render) !== 'function') {
            throw new TypeError(
                "Expected Sticky to have a property 'render' which is a function"
            );
        }
    }

    componentDidMount() {
        if (!this.context || !this.context.subscribe) {
            throw new TypeError("Expected Sticky to be mounted within StickyContainer, which provides a subscribe function");
        }
        this.context.subscribe(this.handleContainerEvent);
    }

    componentWillUnmount() {
        if (this.context && this.context.unsubscribe) {
            this.context.unsubscribe(this.handleContainerEvent);
        }
    }

    componentDidUpdate() {
        this.placeholder.style.paddingBottom = this.props.disableCompensation
                                               ? 0
                                               : `${this.state.isSticky ? this.state.calculatedHeight : 0}px`;
    }

    handleContainerEvent({
                             distanceFromTop,
                             distanceFromBottom,
                             eventSource
                         }) {
        const parent = this.context.parent;

        let preventingStickyStateChanges = false;
        const placeholderClientRect = this.placeholder.getBoundingClientRect();

        if (this.props.relative) {
            preventingStickyStateChanges = eventSource !== parent;
            distanceFromTop =
                -(eventSource.scrollTop + eventSource.offsetTop) +
                placeholderClientRect.top;
        }

        const contentClientRect = this.content.getBoundingClientRect();
        const calculatedHeight = contentClientRect.height;

        const bottomDifference =
            distanceFromBottom - this.props.bottomOffset - calculatedHeight;

        const wasSticky = !!this.state.isSticky;
        const isSticky = preventingStickyStateChanges
                         ? wasSticky
                         : distanceFromTop <= -this.props.topOffset &&
                           distanceFromBottom > -this.props.bottomOffset;

        distanceFromBottom =
            (this.props.relative
             ? parent.scrollHeight - parent.scrollTop
             : distanceFromBottom) - calculatedHeight;

        const style = !isSticky
                      ? {}
                      : {
                position: "fixed",
                top:
                    bottomDifference > 0
                    ? this.props.relative
                      ? parent.offsetTop - parent.offsetParent.scrollTop
                      : 0
                    : bottomDifference,
                left: placeholderClientRect.left,
                width: placeholderClientRect.width
            };

        if (!this.props.disableHardwareAcceleration) {
            style.transform = "translateZ(0)";
        }

        this.setState({
            isSticky,
            wasSticky,
            distanceFromTop,
            distanceFromBottom,
            calculatedHeight,
            style
        });
    };

    render() {
        const element = React.cloneElement(
            this.props.render({
                isSticky: this.state.isSticky,
                wasSticky: this.state.wasSticky,
                distanceFromTop: this.state.distanceFromTop,
                distanceFromBottom: this.state.distanceFromBottom,
                calculatedHeight: this.state.calculatedHeight,
                style: this.state.style
            }),
            {
                ref: content => {
                    this.content = ReactDOM.findDOMNode(content);
                }
            }
        );

        return (
            <div>
                <div ref={placeholder => (this.placeholder = placeholder)} />
                {element}
            </div>
        );
    }
}
Sticky.contextType = StickyContext;
Sticky.defaultProps = {
    relative: false,
    topOffset: 0,
    bottomOffset: 0,
    disableCompensation: false,
    disableHardwareAcceleration: false
};
